module.exports = __webpack_public_path__ + "img/testimonials_cards.8a7e77fa.png";